import "./ListingBodyComponent.scss";
import ProductCardComponent from "../../ProductCard/ProductCardComponent";
import ListingFilterSectionComponent from "../ListingFilterSection/ListingFilterSectionComponent";
import NotFoundComponent from "../../NotFound/NotFoundComponent";
import { useTranslation } from "react-i18next";

const ListingBodyComponent = (props) => {
  const { t } = useTranslation();

  const {
    categoryList,
    selectedCatIds,
    selectedSubCatIds,
    subCatList,
    checkBoxOnChange,
    onSelectSubCat,
    onSearchClicked,
    sortOption,
    filterOption,
    selectedSort,
    setSelectedSort,
    isFetching,
    setSelectedFilter,
    onFilterClicked,
    formattedListing,
    placeHolderMsg,
    type,
    showSearch,
    showSort,
    showFilter,
    showCategories,
    paginateCB,
  } = props;

  return (
    <>
      <ListingFilterSectionComponent
        categoryList={categoryList}
        selectedCatIds={selectedCatIds}
        selectedSubCatIds={selectedSubCatIds}
        subCatList={subCatList}
        checkBoxOnChange={checkBoxOnChange}
        onSelectSubCat={onSelectSubCat}
        // searchText={searchText}
        // setSearchText={setSearchText}
        onSearchClicked={onSearchClicked}
        searchPlaceHolder={placeHolderMsg}
        showSearch={showSearch}
        showSort={showSort}
        showFilter={showFilter}
        showCategories={showCategories}
        sortOption={sortOption}
        filterOption={filterOption}
        sortSelected={selectedSort}
        setSelectedSort={setSelectedSort}
        isLoading={isFetching}
        setSelectedFilter={(value) => {
          setSelectedFilter(value);
          onFilterClicked(value);
        }}
      />
      <div className="mgt-3">
        {isFetching || !formattedListing.length ? (
          ""
        ) : (
          <span className="count-text-head">
            {t("We found")} {formattedListing.length} role play
            {formattedListing.length > 1 ? "s" : ""} {t("for you")}
          </span>
        )}
        <div className="row coursecard-row videosection-cont">
          {formattedListing.length > 0 ? (
            formattedListing.map((v, i) => {
              return (
                <ProductCardComponent
                  {...v}
                  key={`${type}-${i + 1}`}
                  cardClassName="videocard"
                  lastKey={formattedListing.length === i + 1}
                  refInfo={paginateCB}
                />
              );
            })
          ) : (
            <NotFoundComponent
              width={400}
              height={419}
              showBtn={false}
              showMsg={true}
              msgLine={t("Nothing here, yet.")}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ListingBodyComponent;
